export enum ReviewPreset {
  DEFAULT = '',
  MEDICAL_BACKGROUND = 'MEDICAL_BACKGROUND',
  GENERIC_DEVICE_GROUP = 'GENERIC_DEVICE_GROUP',
  MEDICAL_ALTERNATIVE = 'MEDICAL_ALTERNATIVE',
  DEVICE_SPECIFIC_SEARCH = 'DEVICE_SPECIFIC_SEARCH',
  SIMILAR_DEVICE_SPECIFIC_SEARCH = 'SIMILAR_DEVICE_SPECIFIC_SEARCH',
  CUSTOM = 'CUSTOM',
}
